import { render, staticRenderFns } from "./NewProducts.vue?vue&type=template&id=354235c0&scoped=true"
import script from "./NewProducts.vue?vue&type=script&lang=js"
export * from "./NewProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354235c0",
  null
  
)

export default component.exports